<template>
  <div class="login-box">
    <el-card class="box-card">
      <div class="flex flex-h-center">
        <el-menu :text-color="$store.state.theme === 'dark' ? '#ffffff' : '#303030'" active-text-color="#E6A23C"
          :default-active="tab" mode="horizontal" @select="handleSelect">
          <el-menu-item index="wechat" class="margin-x mt"><span class="mt1">{{ $t('微信登录') }}</span></el-menu-item>
          <el-menu-item index="phone" class="margin-x"><span class="mt1">{{ $t('手机登录') }}</span></el-menu-item>
          <el-menu-item index="email" class="margin-x"><span class="mt1">{{ $t('邮箱登录') }}</span></el-menu-item>
        </el-menu>
      </div>
      <el-divider class="mt0"></el-divider>

      <div v-if="tab == 'wechat'" style="height: 400px;">
        <iframe :src="src" width="100%" height="100%" frameborder="0"></iframe>
      </div>
      <el-form ref="form" :model="form" label-width="0" v-if="tab != 'wechat'">
        <el-form-item class="margin-lt">
          <el-input :placeholder="tab == 'email' ? $t('请输入邮箱') : $t('请输入手机号码')" v-model="form.phone"
            class="input-with-select">
            <el-select @change="saveType" v-model="type" slot="prepend" placeholder="" v-if="tab == 'phone'">
              <el-option :label="'+86（' + $t('中国') + '）'" value="+86"></el-option>
              <el-option :label="'+61（' + $t('澳大利亚') + '）'" value="+61"></el-option>
              <el-option :label="'+62（' + $t('印度尼西亚') + '）'" value="+62"></el-option>
              <el-option :label="'+60（' + $t('马来西亚') + '）'" value="+60"></el-option>
              <el-option :label="'+91（' + $t('印度') + '）'" value="+91"></el-option>
              <el-option :label="'+63（' + $t('菲律宾') + '）'" value="+63"></el-option>
              <el-option :label="'+1（' + $t('加拿大') + '）'" value="+1"></el-option>
              <el-option :label="'+64（' + $t('新西兰') + '）'" value="+64"></el-option>
              <el-option :label="'+886（' + $t('台湾') + '）'" value="+886"></el-option>
              <el-option :label="'+852（' + $t('香港') + '）'" value="+852"></el-option>
              <el-option :label="'+853（' + $t('澳门') + '）'" value="+853"></el-option>
              <el-option :label="'+44（' + $t('英国') + '）'" value="+44"></el-option>
              <el-option :label="'+81（' + $t('日本') + '）'" value="+81"></el-option>
              <el-option :label="'+82（' + $t('韩国') + '）'" value="+82"></el-option>
              <el-option :label="'+001（' + $t('美国') + '）'" value="+001"></el-option>
              <el-option :label="'+65（' + $t('新加坡') + '）'" value="+65"></el-option>
              <el-option :label="'+66（' + $t('泰国') + '）'" value="+66"></el-option>
              <el-option :label="'+84（' + $t('越南') + '）'" value="+84"></el-option>
            </el-select>
          </el-input>
          <div v-if="type == '+886'" class="tip">*{{ $t('不需要输入0即可加入') }}</div>
        </el-form-item>



        <el-form-item class="margin-lt">
          <el-input :type="flag ? 'text' : 'password'" v-model="form.password" :placeholder="$t('请输入密码')">

            <div @click="setFlag()" class="pointer" :class="{ 'password-view': !flag }" slot="suffix">
              <i class="el-input__icon el-icon-view"></i>
            </div>

          </el-input>
        </el-form-item>


        <el-form-item class="margin-lt">
          <div class="flex flex-between">
            <el-input :placeholder="$t('请输入验证码(数字相加所得的结果)')" class="flex1" v-model="form.captcha"></el-input>
            <el-image class="pointer margin-l" @click="loadPicCaptcha" :src="pic_captcha_src" style="width:100px">
            </el-image>
          </div>
        </el-form-item>


        <div class="flex flex-between">
          <!-- <a class="st" href="/regist">{{$t('立即注册')}}</a> -->
          <a class="st ul" :href="`/regist?flag=1&tab=${tab}`">{{ $t('忘记密码') }}</a>
        </div>

        <el-form-item>
          <el-button class="block" round type="primary" @click="login">{{ $t('登录') }}</el-button>

        </el-form-item>
        <div class="flex flex-h-center"><span class="st1">{{ $t('还没有账号') }}! </span><a :href="`/regist?tab=${tab}`"
            class="margin-l st ul">{{ $t('立即注册') }}</a></div>

      </el-form>
    </el-card>
   
    <div style="width: 450px;" class="margin-t"><el-divider>{{ $t('或使用以下方式登录') }}</el-divider></div>
    <div class="flex flex-h-center margin-t">
      
      <AppleLoginBtn :key="theme" :clientId="appleClientId" :redirectUri="appleRedirectUri"
        @apple-login="handleAppleLogin" @apple-error="handleAppleError" />
    </div>
  </div>
</template>

<script>
import AppleLoginBtn from "@/components/AppleLoginBtn.vue";

export default {
  components: { AppleLoginBtn },
  data: function () {
    return {
      // 替换成你苹果后台配置的参数
      appleClientId: "com.ptefighter.web",
      appleRedirectUri: "https://www.ptefighter.com/apple/callback",
      tab: "wechat",
      type: "+86",
      form: {
        phone: '',
        password: '',
        captcha: '',
        key: ''
      },
      pic_captcha_src: "",
      flag: false
    }
  },

  computed: {
    lang: function () {
      return this.$store.state.lang
    },

    theme: function () {
      return this.$store.state.theme
    },

    src: function () {
      return "https://open.weixin.qq.com/connect/qrconnect?appid=wx62ed850a6918bf20&redirect_uri=" +
        encodeURIComponent("https://www.ptefighter.com/login") +
        "&response_type=code&scope=snsapi_login&state=STATE&lang=" + this.lang + "&style=" + (this.theme == 'dark' ? 'white' : 'black') + "#wechat_redirect";
    },
    refer: () => {
      let path = localStorage.getItem("login_refer") || '/';
      if (path.indexOf("/login") == 0) {
        path = "/"
      }
      return path;
    }
  },

  created() {
    this.type = localStorage.getItem("phone_type") || "+86";
    this.loadPicCaptcha();
    let code = this.$route.query.code;
    if (code) {
      this.$http.post("/api/login/wechat", { code: code }).then((res) => {
        localStorage.setItem("token", res.token);
        this.$store.commit("setUser", res.user);
        if (res.user.certificate && res.user.certificate.status == 1) {
          this.$store.commit("set_pte_mode", res.user.certificate.tag);
        }
        this.$message({
          message: this.$t('登录成功'),
          type: 'success'
        });
        this.$router.replace("/main");
      });
    }
  },
  methods: {
    // 苹果登录回调，提交后端校验
    async handleAppleLogin(params) {
      console.log(params)
      try {
        const res = await this.$http.post("/api/login/apple", { openId: params.userData.sub, fullName: { givenName: params.userData.name ? params.name.firstName : undefined, familyName: params.name ? params.name.lastName : undefined } });
        if (res.token) {
          // 登录成功存token跳转
          localStorage.setItem("token", res.token);
          this.$store.commit("setUser", res.user);

          if (res.user.certificate && res.user.certificate.status == 1) {
            this.$store.commit("set_pte_mode", res.user.certificate.tag);
          }
          this.$message({
            message: this.$t('登录成功'),
            type: 'success'
          });
          this.$router.replace("/main");
        }
      } catch (err) {
        this.$message.error("苹果登录校验失败");
      }
    },
    handleAppleError(err) {
      console.error("apple登录异常：", err);
    },
    saveType(val) {
      localStorage.setItem("phone_type", val);
    },

    setFlag() {
      this.flag = !this.flag;
    },
    handleSelect(index) {
      this.tab = index;
    },
    loadPicCaptcha() {
      this.$http.get("/captcha/api/math").then((data) => {
        this.pic_captcha_src = data.img;
        this.form.key = data.key;
      });
    },

    login() {
      if (this.tab == 'phone' && (this.form.phone.replace(/\d/g, '').length > 0 || this.form.phone.length < 6)) {
        this.$message({
          message: '手机号码错误！',
          type: 'primary'
        });
      } else if (this.tab == 'email' && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.form.phone)) {
        this.$message({
          message: '邮箱格式错误！',
          type: 'primary'
        });
        return;
      } else if (this.form.password.length < 6) {
        this.$message({
          message: '密码最少6位！',
          type: 'primary'
        });
        return;
      } else if (this.form.captcha.length == 0) {
        this.$message({
          message: '请输入验证码',
          type: 'primary'
        });
        return;
      } else {
        this.form["phone_type"] = this.type;
        this.$http.post("/api/login", this.form).then((res) => {
          localStorage.setItem("token", res.token);
          this.$store.commit("setUser", res.user);

          if (res.user.certificate && res.user.certificate.status == 1) {
            this.$store.commit("set_pte_mode", res.user.certificate.tag);
          }
          this.$message({
            message: this.$t('登录成功'),
            type: 'success'
          });
          this.$router.replace("/main");
        }).catch(() => {
          this.loadPicCaptcha();
        })
      }
    }
  },
};
</script>

<style scoped>
.login-box {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.el-select {
  width: 160px;
}

.input-with-select>>>.el-input-group__prepend {
  background-color: #fff;
  color: #E6A23C;
}

.el-form-item {
  margin-top: 30px;
}

.btn {
  margin-left: 20px;
}

.login-box>>>.el-input-group__append {
  padding: 0 !important;
}

.tip {
  color: red;
  margin-bottom: -20px;
}
</style>
